<img src="/images/about/instgram.webp" alt="Instagram Logo" class="instagram-logo" [width]="size" [height]="size" />
<span>{{appname}}</span>